import { createTaskBaseFileStore } from "./createTaskBaseFileStore";
import { requestDownloadFullTaskZip, requestZipFullTaskDownload } from "api/task.api";
import { Task } from "pages/project/task/task.typing";

export const useTaskFileStore = createTaskBaseFileStore<Task>(
  "task",
  (task, currentLanguage, hubConnectionId) => requestZipFullTaskDownload(task.id, currentLanguage, hubConnectionId),
  (id, guid) => requestDownloadFullTaskZip(id, guid)
);
